import Image from 'next/image';
import React from 'react';

type StarsProps = {
  /** 0-5 float (e.g. 4.4) */
  rating: number;
  /** pixel size of the icon (square) */
  size?: number;
  className?: string;
};

export default function Stars({ rating, size = 18, className = '' }: StarsProps) {
  const full = Math.round(rating);          // simple whole-star display

  return (
    <div className={`flex gap-0.5 ${className}`}>
      {Array.from({ length: 5 }).map((_, i) =>
        i < full ? (
          <Image
            key={i}
            src="/svg/star.svg"
            alt="Star"
            width={size}
            height={size}
          />
        ) : (
          <svg
            key={i}
            width={size}
            height={size}
            viewBox="0 0 24 24"
            fill="none"
            className="text-yellow-400"
          >
            <path
              d="M12 17.3l-6.18 3.25 1.18-6.88L2 8.77l6.91-1L12 1.5l3.09 6.27 6.91 1-5 4.9 1.18 6.88L12 17.3z"
              stroke="currentColor"
              strokeWidth="2"
              strokeLinecap="round"
              strokeLinejoin="round"
            />
          </svg>
        ),
      )}
    </div>
  );
}
